import fitvids from "fitvids";
import LazyLoad from "vanilla-lazyload";
import Cookies from "js-cookie";

const Common = {
  lazyLoadInstance: null,

  init: function () {
    this.lazyLoadInstance = new LazyLoad();

    this.events();
    this.popup();
  },

  events: function () {
    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Fitvids
    fitvids();

    // Video.
    $(".flex-video__overlay").on("click", function () {
      $(this).parent().addClass("playing").find("video")[0].play();
    });

    $(".reference__title").click(function () {
      $(this)
        .parent()
        .toggleClass("active")
        .find(".reference__content")
        .slideToggle(400);
    });

    $(".dropdown__current").on("click", function () {
      $(this).parent().toggleClass("open");
    });

    $(document).mouseup(function (e) {
      let container = $(".dropdown");

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("open");
      }
    });
  },

  popup() {
    $("body").on("click", ".js-close-popup", function (e) {
      e.preventDefault();
      $(this).closest(".popup").removeClass("active");
    });

    $("body").on("click", ".spec-no", function (e) {
      //$(this).closest('.only-spec-step').hide().next().fadeIn(); //Disable second step

      Cookies.set("i_am_specialist", false, {
        expires: 7,
      });
      setTimeout(() => {
        location.reload();
      }, 50);
    });

    $("body").on("click", ".spec-yes", function () {
      Cookies.set("i_am_specialist", true, {
        expires: 7,
      });
      setTimeout(() => {
        location.reload();
      }, 50);
    });
  },
};

export default Common;
